import { render, staticRenderFns } from "./payollHistory.vue?vue&type=template&id=803c8e0e&scoped=true"
import script from "./payollHistory.vue?vue&type=script&lang=js"
export * from "./payollHistory.vue?vue&type=script&lang=js"
import style0 from "./payollHistory.vue?vue&type=style&index=0&id=803c8e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803c8e0e",
  null
  
)

export default component.exports